import { useRef, useState } from "react";
import { useIntersectionObserver } from "./useIntersectionObserver";

/** Only changes state to isOnScreen once then disables the observer */
export function useIsOnScreen({ rootMargin = "500px" } = { rootMargin: "500px" }) {
  const ref = useRef(null);
  const [isOnScreen, setIsOnScreen] = useState(false);
  useIntersectionObserver({
    target: ref,
    rootMargin,
    enabled: !isOnScreen,
    deps: [isOnScreen],
    onIntersect: ([{ isIntersecting }]) => {
      setIsOnScreen(isIntersecting);
    },
  });
  return {
    ref,
    isOnScreen,
  };
}
